<template>
  <span
    :class="classes"
  >
    {{ showCount ? totalUnread : null }}
  </span>
</template>

<script>
  import { CounterService } from '@/web/services/counters'

  export default {
    props: {
      showCount: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        totalUnread: 0
      }
    },
    computed: {
      classes() {
        return {
          'is-hidden': this.totalUnread<=0,
          '-large -primary c-header__notification-mark': !this.showCount,
          'o-count': this.showCount
        }
      }
    },

    async created() {
      CounterService.getCounters().then(data => {
        this.totalUnread = data?.default_unread + data?.chat_unread
        this.hasNewMessages = data?.new_message_since_last_view
      })
    }
  }
</script>

